import {Container} from "react-bootstrap";
import React from "react";

export const NotFound : React.FC = () =>{
    return (<Container fluid className="px-lg-4 px-xl-5">
        404 Not found
    </Container>);
}
